/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Despacho from "../Formularios/Formulario_Despacho";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";

const Dialogo_Despacho = ({realizado, cerrar, datos}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, abrirCargador} = useLoaders({logo: logo})
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: realizado, funcionDos: cerrar})

    const guardarDatos = async () => {


        let entidad = await obtenerEntidad()
        abrirCargador('Subiendo datos...')
        entidad.fecha = new Date().getTime()
        let dox = await guardarDoc('despachos', entidad)
        if (dox.res) {
            nuevoAviso({aviso: 'Actualizando fechas'})
            setTimeout(() => {
                terminar({aviso: 'Datos subidos con exito'})
            }, 500)
        } else {
            terminar({aviso: 'Algo no salio bien, por favor intentalo nuevamente', variante: 'erorr'})
        }

    }

    const borrar = async () => {
        await borrarDoc('despachos', datos.id)
        terminar({aviso: 'Registro borrado'})
    }

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Cargador/>

            <Avisos/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Despacho props={props}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => guardarDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }

        </Grid2>
    )

}
export default Dialogo_Despacho